import React from "react";
import { View } from "react-native";
import { StyleSheet, TouchableOpacity } from "react-native";
import { Button as _Button } from "src/common/assets/mixins";
import Text from "./text";
import Button from "./button";
import { ImageMapper } from "src/common/assets/images";
import { AddressType } from "src/common/types/response/user";
import translate from "libs/locale";
import { Image } from "src/common/components/image";
import { Address } from "../types/auth";

const AddressItem = ({
  data,
  style,
  containerStyle,
  textStyle,
  onEdit,
  onPress,
}: {
  data: Address;
  style?: object;
  textStyle?: object;
  containerStyle?: object;
  onEdit?: (data: Address, id: string) => void;
  onPress?: (id: string) => void;
}) => {
  const Container = onPress ? TouchableOpacity : (View as React.ElementType);
  return (
    <Container
      style={[styles.container, containerStyle]}
      onPress={() => onPress(data.location?._id)}
    >
      <View style={[styles.root, style]}>
        <View style={{flex:1}}>
          <Text
            style={[styles.name, styles.addressName, textStyle]}
          >{`${data.address_name}`}</Text>
          <Text
            style={[styles.name, textStyle]}
          >{`${data.line_1}, ${data.line_2}`}</Text>
          <Text
            style={[styles.name, textStyle]}
          >{`${data.city}, ${data.state}`}</Text>
          <Text style={[styles.name, textStyle]}>{`${data.pin}`}</Text>
          <Text style={[styles.name, styles.phone, textStyle]}>{`${
            data.phone || translate("phoneNA")
          }`}</Text>
        </View>
        {onEdit && (
          <Button
            style={styles.edit}
            solid={false}
            onPress={() => onEdit(data, data?.location?._id)}
          >
            <Image source={ImageMapper.Edit} style={styles.icon} />
          </Button>
        )}
      </View>
    </Container>
  );
};

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 5,
  },
  root: {
    flex: 1,
    borderRadius: 15,
    backgroundColor: "#FCFCFC",
    marginVertical: 8.25,
    padding: 20,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.27,
    shadowRadius: 2,
    flexDirection: "row",
    elevation: 4,
    justifyContent: "space-between",
    alignItems: undefined,
  },
  name: {
    fontSize: 14,
    lineHeight: 15,
    color: "#636E72",
    marginBottom: 7,
  },
  addressName: {
    fontFamily: "MontserratBold",
  },
  phone: {
    marginBottom: 0,
  },
  edit: {
    alignSelf: "center",
  },
  icon: {
    height: 24,
    width: 24,
  },
});

export default AddressItem;
